import { createFileRoute } from "@tanstack/react-router";
import { lazyNamed } from "@/lib/lazy-route";
import { internalWallInsulationLp } from "@/content/landing/internal-wall-insulation";
import { pageSeo, serviceJsonLdScript } from "@/lib/seo";
import { SITE } from "@/lib/site";
import { withServiceLcpPreload } from "@/lib/service-lcp-preload";
import { SERVICE_PAGE_OG_IMAGES } from "@/lib/service-page-og-images";

const LpInternalWallInsulationPage = lazyNamed(
  () => import("@/components/landing/lp-internal-wall-insulation"),
  "LpInternalWallInsulation",
);

const PATH = "/internal-wall-insulation";
const TITLE =
  "Internal Wall Insulation South Wales | PAS 2030 Certified | CRS Energy";
const DESCRIPTION =
  "PAS 2030 certified internal wall insulation across South Wales. Design-stage risk assessment, thermal-bridge management, moisture-aware build-ups, insurance-backed guarantee.";

export const Route = createFileRoute("/internal-wall-insulation")({
  head: () =>
    withServiceLcpPreload(PATH, {
    ...pageSeo({
      path: PATH,
      title: TITLE,
      description: DESCRIPTION,
      image: SERVICE_PAGE_OG_IMAGES[PATH],
      ogType: "article",
    }),
    scripts: [
      serviceJsonLdScript({
        name: "Internal Wall Insulation",
        description: DESCRIPTION,
        serviceType: "Internal Wall Insulation",
        url: `${SITE.url}${PATH}`,
        image: SERVICE_PAGE_OG_IMAGES[PATH],
      }),
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: internalWallInsulationLp.faqs.map((f) => ({
            "@type": "Question",
            name: f.question,
            acceptedAnswer: { "@type": "Answer", text: f.answer },
          })),
        }),
      },
    ],
  }),
  component: LpInternalWallInsulationPage,
});
